import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authenticate } from "../script/rpc";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const uid = await authenticate(username, password);
      onLogin(uid, password);
    } catch (err) {
      setError(err.message || "Authentication failed.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg,#f0f4ff 0%,#faf5ff 50%,#f0fdf4 100%)",
      fontFamily: "'Inter', system-ui, sans-serif",
      padding: 20,
    }}>
      {/* Decorative blobs */}
      <div style={{ position: "fixed", top: -100, left: -100, width: 400, height: 400, borderRadius: "50%", background: "rgba(124,58,237,0.08)", filter: "blur(60px)", pointerEvents: "none" }} />
      <div style={{ position: "fixed", bottom: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(14,165,233,0.08)", filter: "blur(60px)", pointerEvents: "none" }} />

      <div style={{
        width: "100%", maxWidth: 420, background: "#fff",
        borderRadius: 20, padding: "40px 36px 32px",
        boxShadow: "0 4px 40px rgba(0,0,0,0.12)",
        border: "1px solid #e2e8f0", position: "relative",
        animation: "slideUp 0.4s ease both",
      }}>
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 18, margin: "0 auto 16px",
            background: "linear-gradient(135deg,#7c3aed,#0ea5e9)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 4px 16px rgba(124,58,237,0.3)",
          }}>
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
              <circle cx="17" cy="6"  r="5" fill="white"/>
              <circle cx="6"  cy="26" r="5" fill="white" fillOpacity=".8"/>
              <circle cx="28" cy="26" r="5" fill="white" fillOpacity=".8"/>
              <line x1="17" y1="11" x2="6"  y2="21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              <line x1="17" y1="11" x2="28" y2="21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#0f172a" }}>MLM Network</h1>
        </div>
         {error && (
            <div style={{
              background: "#fef2f2", border: "1px solid #fecaca",
              borderRadius: 8, padding: "10px 14px",
              color: "#dc2626", fontSize: 13, textAlign:"center", marginBottom:'30px'
            }}>
              {error}
            </div>
          )}

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Field label="Username" icon="👤">
            <input
              type="text" value={username} required
              onChange={e => setUsername(e.target.value)}
              placeholder="username"
              style={inputStyle}
              onFocus={e => e.target.style.borderColor = "#7c3aed"}
              onBlur={e => e.target.style.borderColor = "#e2e8f0"}
            />
          </Field>

          <Field label="Password" icon="🔑">
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <input
                type={showPass ? "text" : "password"} value={password} required
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{ ...inputStyle, paddingRight: 40 }}
                onFocus={e => e.target.style.borderColor = "#7c3aed"}
                onBlur={e => e.target.style.borderColor = "#e2e8f0"}
              />
              <button
                type="button" tabIndex={-1}
                onClick={() => setShowPass(s => !s)}
                style={{ position: "absolute", right: 10, background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#94a3b8" }}
              >
                {showPass ? "🙈" : "👁️"}
              </button>
            </div>
          </Field>
          <button
            type="submit" disabled={loading}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              padding: "12px", borderRadius: 10, border: "none",
              background: loading ? "#a78bfa" : "linear-gradient(135deg,#7c3aed,#0ea5e9)",
              color: "#fff", fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "inherit", marginTop: 4,
              boxShadow: "0 4px 14px rgba(124,58,237,0.3)",
              transition: "opacity 0.15s, transform 0.15s",
            }}
            onMouseOver={e => { if (!loading) e.currentTarget.style.opacity = "0.92"; }}
            onMouseOut={e => { e.currentTarget.style.opacity = "1"; }}
          >
            {loading ? <><BtnSpinner />&nbsp;Logging in…</> : <>🌐 Sign In &amp; View Tree</>}
          </button>
        </form>

        <div style={{ marginTop: 24, textAlign: "center", fontSize: 13, color: "#64748b" }}>
          Don't have an account?{" "}
          <Link to="/signup" style={{ color: "#7c3aed", fontWeight: 600, textDecoration: "none" }}>
            Sign Up here
          </Link>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        @keyframes slideUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:translateY(0); } }
        @keyframes spin    { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

function Field({ label, icon, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "flex", alignItems: "center", gap: 5 }}>
        {icon} {label}
      </label>
      {children}
    </div>
  );
}

const inputStyle = {
  width: "100%", boxSizing: "border-box",
  padding: "10px 14px", borderRadius: 8,
  border: "1.5px solid #e2e8f0", outline: "none",
  fontSize: 14, fontFamily: "inherit", color: "#0f172a",
  background: "#f8fafc", transition: "border-color 0.15s",
};

function BtnSpinner() {
  return <div style={{ width: 16, height: 16, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff", animation: "spin 0.7s linear infinite" }} />;
}
